<script setup lang="ts">
import { useTheme } from '@/composables/useTheme';
import AppIcon from './AppIcon.vue';

const { isDark, toggle } = useTheme();
</script>

<template>
  <button type="button" class="icon-btn" aria-label="Tungi rejimni almaştiriş" @click="toggle">
    <AppIcon :name="isDark ? 'sun' : 'moon'" />
  </button>
</template>
